import { IProject } from '../interfaces/IProject';

class ProjectService {
	static chosenProject = 'chosenProject';

	setChosenProject(project: IProject): void {
		localStorage.setItem(ProjectService.chosenProject, JSON.stringify(project));
	}

	removeChosenProject(): void {
		localStorage.removeItem(ProjectService.chosenProject);
	}

	getChosenProject(): IProject | undefined {
		const storedProject = localStorage.getItem(ProjectService.chosenProject);
		return storedProject ? (JSON.parse(storedProject) as IProject) : undefined;
	}
}

export { ProjectService };
